import { connect } from 'react-redux';
import { getActiveDivisionId } from 'redux-core/settings/selectors';

const mapStateToProps = (state) => ({
  activeDivisionId: getActiveDivisionId(state),
});

export default connect(mapStateToProps);
